import { render, staticRenderFns } from "./AuthenticationCreateOrganizer.vue?vue&type=template&id=3f080a9e&scoped=true&"
import script from "./AuthenticationCreateOrganizer.vue?vue&type=script&lang=js&"
export * from "./AuthenticationCreateOrganizer.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationCreateOrganizer.vue?vue&type=style&index=0&id=3f080a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f080a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f080a9e')) {
      api.createRecord('3f080a9e', component.options)
    } else {
      api.reload('3f080a9e', component.options)
    }
    module.hot.accept("./AuthenticationCreateOrganizer.vue?vue&type=template&id=3f080a9e&scoped=true&", function () {
      api.rerender('3f080a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AuthenticationCreateOrganizer.vue"
export default component.exports